import "./style.css";

export const LoadingScreen = () => (
  <div className="loading-screen" id="loading-screen" aria-label="Loading">
    <img className="loading-screen__logo" src="/icons/ik-logo.svg" alt="Loading" />
  </div>
);
